import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const RiskSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const riskContent = content[language].risk;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="risk" 
      ref={sectionRef}
      className="section"
      style={{ background: '#ffffff' }}
    >
      <div className="container">
        {/* Title */}
        <div className={`text-center mb-80 fade-in-up ${isVisible ? 'visible' : ''}`}>
          <h2>{riskContent.title}</h2>
        </div>

        {/* Risk Factors */}
        <div className="grid-2" style={{ gap: '40px' }}>
          {riskContent.factors.map((factor, index) => (
            <div
              key={factor.risk}
              className={`fade-in-up ${isVisible ? 'visible' : ''}`}
              style={{
                padding: '40px 36px',
                background: 'var(--ivory)',
                transitionDelay: `${index * 0.15}s`
              }}
            >
              <h4 className="mb-16" style={{ fontSize: '1.125rem', color: 'var(--charcoal)', fontWeight: 500 }}>
                {factor.risk}
              </h4>
              <div style={{
                width: '40px',
                height: '2px',
                background: 'var(--gold)',
                marginBottom: '20px'
              }} />
              <p style={{ fontSize: '0.9375rem', margin: 0 }}>{factor.mitigation}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RiskSection;
